export default function HiveFlowLoader({
  fullScreen = false,
  label = "Bijen App laden",
  sublabel = "Even alles klaarzetten",
}) {
  const content = (
    <div data-testid="flowhive-loader" className="flex flex-col items-center justify-center text-center">
      <div className="relative h-28 w-28 flex items-center justify-center">
        <div className="absolute bottom-5 h-3 w-16 rounded-full bg-zinc-200/80 blur-sm animate-pulse-soft" />
        <svg viewBox="0 0 96 96" className="h-24 w-24 animate-bee-hover" aria-hidden="true">
          <g className="animate-bee-wing-left">
            <ellipse
              cx="36"
              cy="29"
              rx="13"
              ry="20"
              fill="#E0F2FE"
              stroke="#93C5FD"
              strokeWidth="3"
              opacity="0.86"
              transform="rotate(-28 36 29)"
            />
          </g>
          <g className="animate-bee-wing-right">
            <ellipse
              cx="58"
              cy="29"
              rx="13"
              ry="20"
              fill="#E0F2FE"
              stroke="#93C5FD"
              strokeWidth="3"
              opacity="0.86"
              transform="rotate(28 58 29)"
            />
          </g>
          <ellipse cx="48" cy="55" rx="25" ry="19" fill="#FBBF24" stroke="#92400E" strokeWidth="3" />
          <path
            d="M33 41c4 8 4 20 0 28M48 37c4 10 4 26 0 36M63 41c-4 8-4 20 0 28"
            fill="none"
            stroke="#78350F"
            strokeWidth="5"
            strokeLinecap="round"
            opacity="0.9"
          />
          <circle cx="74" cy="51" r="11" fill="#78350F" />
          <circle cx="78" cy="47" r="2.2" fill="white" />
          <path
            d="M82 43c5-6 8-8 12-8M80 39c1-7 3-10 6-13M24 55c-7-3-13-1-18 3"
            fill="none"
            stroke="#78350F"
            strokeWidth="3"
            strokeLinecap="round"
          />
        </svg>
      </div>
      <div className="font-display text-xl font-bold text-zinc-900">{label}</div>
      <div className="mt-1 text-sm text-zinc-500">{sublabel}</div>
    </div>
  );

  if (fullScreen) {
    return (
      <div
        data-testid="splash-screen"
        className="fixed inset-0 z-50 flex items-center justify-center bg-gradient-to-b from-amber-50 to-white px-6"
        style={{ paddingBottom: "env(safe-area-inset-bottom, 0)" }}
      >
        {content}
      </div>
    );
  }

  return (
    <div className="min-h-[60vh] flex items-center justify-center px-6 py-10">
      {content}
    </div>
  );
}
